const KEY = 'invitation_token';

export function saveInvitationToken(token: string): void {
  localStorage.setItem(KEY, token);
}

export function loadInvitationToken(): string | null {
  return localStorage.getItem(KEY);
}

export function clearInvitationToken(): void {
  localStorage.removeItem(KEY);
}
